import { render } from "./SelectInfo.vue?vue&type=template&id=09b8d49e&scoped=true"
import script from "./SelectInfo.vue?vue&type=script&lang=js"
export * from "./SelectInfo.vue?vue&type=script&lang=js"

import "./SelectInfo.vue?vue&type=style&index=0&id=09b8d49e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-09b8d49e"

export default script